'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRouterDom = require('react-router-dom');

var _lodash = require('lodash');

var _decisivUiUtils = require('decisiv-ui-utils');

var _Link = require('../../styles/common/Link');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledLink(props) {
  var navLinkProps = (0, _lodash.omit)(props, ['modifiers', 'theme']);
  return _react2.default.createElement(_reactRouterDom.Link, navLinkProps);
}

var propTypes = {
  'aria-label': _propTypes2.default.string.isRequired
};

var Link = (0, _decisivUiUtils.buildStyledComponent)('Link', (0, _styledComponents2.default)(UnstyledLink), _Link.styles, {
  modifierConfig: _Link.modifierConfig,
  propTypes: propTypes,
  themePropTypes: _Link.themePropTypes
});

Link.propTypes = {
  'aria-label': _propTypes2.default.string.isRequired
};

exports.default = Link;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/Link/index.js
// module id = 1526
// module chunks = 2